import { useNavigate } from 'react-router';
import { Block } from '../../Components/Block/Block';
import { Container } from '../../components/Container/Container';
import { Spinner } from '../../components/Spinner/Spinner';
import styles from './Gender.module.scss';
import { useFetchData } from '../../services/useFetchData.service';
import { useUserData } from '../../providers/UserDataProvider/useUserData';
import { Title } from '../../components/Title/Title';
import { Image } from '../../components/Image/Image';
import {  useEffect, useState } from 'react';
import { fbSearch } from '../../utils/FacebookEvents';
import { amp2ndScreen, ampGenderSelected } from '../../utils/AmplitudeEvents';
export const Gender = ({dataUrl,theme})=>{
  const [popupStatus,setPopupStatus] = useState(false);
  const navigate = useNavigate();
  const { data } = useFetchData(dataUrl);
  const { userData, setUserData } = useUserData();
  useEffect(()=>{
    amp2ndScreen();
  },[])
  useEffect(() => {
    if(theme) {
      document.body.setAttribute('data-theme', theme);
    }else {
      document.body.removeAttribute('data-theme');
    }
  }, [theme]);
  if (!data ) {
    return <Spinner />;
  }
  const NEXT_PAGE_URL = '/age/';
  const { title, question,answer,answerButtonText,genders } = data;
  const handleGenderSelect = (gender) => {
    setUserData({ ...userData, gender });
    fbSearch();
    ampGenderSelected(gender);
    setTimeout(() => navigate(NEXT_PAGE_URL), 500);
  };
  return (
    <>
      <Block>
        <Container className={styles.section}>
          {title && <Title className={styles.title}>{title}</Title>}
          {question && <div className={styles.question} onClick={()=>{setPopupStatus(true)}}>{question}</div>}
          <div className={styles.answers}>
            {genders.map((gender) => (
              <div
                key={gender}
                className={styles.answer}
                onClick={() => handleGenderSelect(gender.name)}
              >
                {gender.icon && <Image src={gender.icon} className={styles.image}/>}
                {gender.name && <div className={styles.name}>{gender.name}</div>}
              </div>
            ))}
          </div>
          {popupStatus && 
          <div className={styles.popup}>
            <div className={styles.popupWrapper}>
              <div className={styles.popupContent}>
                <h2 className={styles.popupTitle}>{question}</h2>
                <div className={styles.popupText}>{answer}</div>
                <div className={styles.popupButton} onClick={()=>{setPopupStatus(false)}}>{answerButtonText}</div>
              </div>
            </div>
          </div>
          }
          
        </Container>
      </Block>
    </>
  )
}